import styled from 'styled-components';

export const StyledTopbar = styled.div`
  font-size: 13px;
  background: ${props => props.background_topbar || '#e95513'};
  color: ${props => props.color_topbar};
  text-align: ${props => props.align_topbar};
`